module.exports = __webpack_public_path__ + "static/media/BE1Converter.7f2717f3.jpg";